import React, { useState } from "react";
import "../../styles/TextField.css"; // Custom CSS file for styling
import eyeIcon from "../../assets/eye_icon.svg";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const PasswordInput = ({value, onChange, error }) => {

    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

   const togglePasswordVisibility = () => {
     setIsPasswordVisible(!isPasswordVisible);
    };


  return (
    <div>
    <div className="textfield-outer-container">
      <input className="input-text-field" type={isPasswordVisible ? "text" : "password"} onChange={(e) => onChange(e.target.value)} value={value}/>
      <div className="eye" onClick={togglePasswordVisibility}>
          {isPasswordVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
      </div>
    </div>
    {error && (
      <div
        style={{
          display: "flex",
          justifyContent: "start",
          marginTop: "2px",
          textAlign: "left",
          width: "13rem"
        }}
      >
        <span style={{ color: "red", fontSize: "14px" }}>
          {error}
        </span>
      </div>
    )}
  </div>
  );
};

export default PasswordInput;
